;
define("transaction_line_views_selected_option_color.tpl", function(){});

